// const CLIENT_URL = "http://localhost:3000/";
const CLIENT_URL = "https://www.byrneintranet.com";
// const API_URL = "http://localhost:5000/";
//const API_URL = "https://byrneprod.remodigital.in/";
const API_URL = "https://byrneintranetservice.byrneintranet.com/"

const ALLOWED_DOMAINS = ["byrnerental.com","vtks.in"]



const correctPassword = "B4rne@#$789";


export { API_URL, CLIENT_URL, ALLOWED_DOMAINS, correctPassword };
